import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

const TabFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		await state.wrapContainer(
			formatter.openTag("tab", {
				name: node.attrs.name,
				icon: node.attrs.icon,
				tag: node.attrs.tag,
			}),
			formatter.closeTag("tab"),
			node,
			async () => await state.renderContent(node),
			formatter.indentsContainers,
		);
	};

export default TabFormatter;
